export default "__VITE_ASSET__DF6$09r9__"